import {WorkspaceView} from "./WorkspaceView";

export default class WorkspaceViewsData {
	constructor(
		public readonly views: WorkspaceView[],
		public readonly favourites: string[]
	) {}
}